import { render, staticRenderFns } from "./async-routes-config.vue?vue&type=template&id=d11b3622&"
import script from "./async-routes-config.vue?vue&type=script&lang=js&"
export * from "./async-routes-config.vue?vue&type=script&lang=js&"
import style0 from "./async-routes-config.vue?vue&type=style&index=0&id=d11b3622&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports